// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__BVoU6","wrapper":"Profile_wrapper__hTwrt","content":"Profile_content__QbCOE","fullWidth":"Profile_fullWidth__5JFJ1"};